import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBrowseItems as getBrowseItemsAction,
  resetBrowseItems, resetBrowseItemsActions,
  setBrowseItemsFilters,
} from 'store/browse-items/actions';
import {
  getBrowseItems as getBrowseItemsSelector,
  getBrowseItemsLoadingState as getBrowseItemsLoadingStateSelector,
  getBrowseItemsFilters as getBrowseItemsFiltersSelector,
  getQueryArray, getSuggestedBrowseItemsOptions as getSuggestedBrowseItemsOptionsSelector,
} from 'store/browse-items/selectors';

import Catalogue from './catalogue';
import { FILTER_KEYS } from '../../../../store/browse-items/fixtures';
import { getSuggestedItemsLoadingState } from '../../../../store/suggested-items/selectors';
import { resetSuggestedItems as resetSuggestedItemsAction } from '../../../../store/suggested-items/actions';

const {
  CATEGORIES,
  MANUFACTURERS,
  TAGS,
  QUANTITY,
  ITEMS,
  STORAGE,
} = FILTER_KEYS;

const PickItemsFromCatalogue = ({ onSubmit, ...props }) => {
  const dispatch = useDispatch();
  const [ids, setIds] = useState([]);
  const data = useSelector(getBrowseItemsSelector);
  const filters = useSelector(getBrowseItemsFiltersSelector);
  const loading = useSelector(getBrowseItemsLoadingStateSelector);
  const query = useSelector(getQueryArray);
  const suggestedBrowseItemsOptions = useSelector(getSuggestedBrowseItemsOptionsSelector);
  const isSuggestionLoading = useSelector(getSuggestedItemsLoadingState);

  const handleReset = () => {
    dispatch(resetBrowseItems());
    dispatch(resetBrowseItemsActions());
    dispatch(getBrowseItemsAction());
  };

  const handleLoadMore = () => {
    dispatch(getBrowseItemsAction());
  };

  const handleChange = (id) => {
    if (ids.includes(id)) {
      setIds(ids.filter((i) => i !== id));
    } else {
      setIds([...ids, id]);
    }
  };

  const handleFilterChange = (values) => {
    dispatch(setBrowseItemsFilters(values));

    dispatch(getBrowseItemsAction());

    // isClearData.current = false;
  };

  const handleQueryChange = ({ type, ...option }) => {
    handleFilterChange({
      ...filters,
      ...(type === 'tag' ? { [FILTER_KEYS.TAGS]: [...filters[FILTER_KEYS.TAGS], { ...option, field: FILTER_KEYS.TAGS }] } : {}),
      ...(type === 'item' ? { [FILTER_KEYS.ITEMS]: [...filters[FILTER_KEYS.ITEMS], { ...option, field: FILTER_KEYS.ITEMS }] } : {}),
    });
  };

  const handleQueryParamDelete = ({ type, value }) => {
    const { [type]: updatedField, ...restFilters } = filters;

    handleFilterChange({
      ...restFilters,
      ...([TAGS, ITEMS].includes(type) ? { [type]: updatedField.filter((filter) => filter.id !== value) } : {}),
      ...([CATEGORIES, STORAGE].includes(type) ? { [type]: updatedField.filter((itemId) => itemId !== value) } : {}),
      ...(type === MANUFACTURERS ? {
        [type]: updatedField.filter((filter) => {
          return (Array.isArray(value) ? !value.includes(filter) : filter !== value);
        }),
      } : {}),
      ...(type === QUANTITY && { [type]: value || null }),
      ...(type === FILTER_KEYS.QUERY ? { [type]: null } : {}),
    });
  };

  const handleSubmit = () => {
    onSubmit(ids);
  };

  const handleSearchQueryReset = () => {
    dispatch(resetSuggestedItemsAction());
  };

  useEffect(() => {
    if(props.isOpened) {
      handleFilterChange({
        ...filters,
        [FILTER_KEYS.SORT_DIRECTION]: 'itemName',
      });
      dispatch(getBrowseItemsAction());
    } else {
      dispatch(resetBrowseItems());
      dispatch(resetBrowseItemsActions());

      setIds([]);
    }
  }, [props.isOpened]);

  return (
    <Catalogue
      {...props}
      noContentMessage="There are no items to display"
      selectedIds={ids}
      data={data}
      isLoading={loading}
      hasMore={filters[FILTER_KEYS.HAS_MORE]}
      onLoadMore={handleLoadMore}
      onReset={handleReset}
      onFilterChange={handleFilterChange}
      onQueryParamDelete={handleQueryParamDelete}
      filters={filters}
      query={query}
      suggestions={suggestedBrowseItemsOptions}
      isSuggestionLoading={isSuggestionLoading}
      onSuggestionSelect={handleQueryChange}
      onSuggestionsReset={handleSearchQueryReset}
      onChange={handleChange}
      onSubmit={handleSubmit}
      cancelActionAvailable={false}
    />
  );
};

export default PickItemsFromCatalogue;
